import {useState} from 'react';

import Navbar from 'components/Navbar/Navbar';
import Sidebar from 'components/Sidebar/Sidebar';
import './LayoutPage.scss';
import SmScreenMessages from 'components/SmScreenMessages/SmScreenMessages';
import useMediaQuery from 'hooks/useMediaQuery';

interface Props {
  children: React.ReactNode;
  navbarChildren?: React.ReactNode;
  className?: string;
  backUrl?: string;
}

export default function LayoutPage({children, navbarChildren, className, backUrl}: Props) {
  const [showSidebar, setShowSidebar] = useState(false);

  const isTabletOrMobileScreen = useMediaQuery('(max-width: 991px)');

  const toggleSidebar = () => {
    setShowSidebar((prevState) => !prevState);

    document.body.style.overflow = !showSidebar ? 'hidden' : '';
  };

  return (
    <div className={`layout-page ${className || ''} ${showSidebar ? 'layout-page--sidebar-open' : ''}`}>
      <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="layout-page__container">
        <div className="layout-page__overlay" />
        <div className="layout-page__navbar-wrapper">
          <Navbar toggleSidebar={toggleSidebar} showSidebar={showSidebar} backUrl={backUrl}>
            {navbarChildren}
          </Navbar>
          {isTabletOrMobileScreen && <SmScreenMessages />}
        </div>
        <main className="layout-page__content">{children}</main>
      </div>
    </div>
  );
}
